import React from 'react';

import { isLoggedIn } from '../../../services/auth';

const SignedInContent = ({ children }) => {
    if (!isLoggedIn()) return null;
    return children;
};

export default SignedInContent;
